export function getScrollTop(iframe: HTMLIFrameElement): number {
  if (iframe.contentDocument!.documentElement && iframe.contentDocument!.documentElement.scrollTop) {
    return iframe.contentDocument!.documentElement.scrollTop;
  } else if (iframe.contentDocument!.body && iframe.contentDocument!.body.scrollTop) {
    return iframe.contentDocument!.body.scrollTop;
  }
  return 0;
}
